import { makeLogger } from "@/shared/consola";
import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

const logger = makeLogger("issued-certificates.service");

const makeCertificatesEndpoint = (playerUUID) => `players/${playerUUID}/issued-certificates`;

export const issuedCertificatesService = {
    async getAllFor(playerUUID, { page, size, search } = {}) {
        logger.trace(`getAllFor(${playerUUID}) fired!`);
        return ajaxCall
            .get(`${makeCertificatesEndpoint(playerUUID)}`, {
                params: { page, size, search },
            })
            .catch(handleErrorByMessage());
    },
    async getOnePublic(playerUUID, certificateUUID) {
        logger.trace(`getOnePublic(${playerUUID}) cert uuid(${certificateUUID}) fired!`);
        return ajaxCall
            .get(`${makeCertificatesEndpoint(playerUUID)}/${certificateUUID}`)
            .catch(handleErrorByMessage({ rethrow: false }));
    },
    async regenerate(playerUUID, certificateUUID) {
        logger.trace(`regenerate(${playerUUID}) cert uuid(${certificateUUID}) fired!`);
        return ajaxCall
            .patch(`${makeCertificatesEndpoint(playerUUID)}/${certificateUUID}`, {})
            .catch(handleErrorByMessage({ rethrow: false }));
    },
};
